module.exports = __webpack_public_path__ + "static/media/veneto-village-26.9e236147.jpg";